// import * as components from './components'; - Для примера
import * as directives from "./directives";
import * as filters from "./filters";
import Core from "./core";

export default Core;

const install = Core.install;

// Если не импортируются компоненты как на 1 строке,
// то можно самому указать список глобальных компонентов
const components = {};

Core.install = (Vue, args) => {
  install.call(Core, Vue, {
    components,
    directives,
    filters,
    ...args
  });
};
